module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"PicoNFT","short_name":"PicoNFT","start_url":"/","background_color":"#0078ca","theme_color":"#0078ca","display":"standalone","icon":"src/images/picovideo-icon.png","crossOrigin":"use-credentials","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","include_favicon":true,"cacheDigest":"a089e6aabc1d7fef3f7d4af8f5342c3e"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
